module.exports = __webpack_public_path__ + "static/media/bosscheomroep.4cd2da55.png";